import { createGlobalStyle } from 'styled-components';

/*
 * ONLY add to this file if you need to override the default Ant Design styles
 * across ALL instances of a component. Ensure that you leave a comment that
 * details what exactly this is fixing.
 */
export const GlobalStyles = createGlobalStyle`
  // To prevent weird slow color transition on menu items when theme is changed.
  .ant-menu-item a {
    transition: color 0s;
  }

  // To prevent a menu from having a border that overlaps the side bar border
  // when collapsed.
  .ant-menu-root{
    border-inline-end: none !important;
  }

  // Global scrollbar styling that matches the theme
  ::-webkit-scrollbar {
    width: ${({ theme }) => theme.sizeXS}px;
    height: ${({ theme }) => theme.sizeXS}px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colorFillQuaternary};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colorFillSecondary};
    border-radius: ${({ theme }) => theme.borderRadiusXS}px;

    &:hover {
      background: ${({ theme }) => theme.colorFillContent};
    }
  }

  // Firefox scrollbar styling
  * {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) =>
      `${theme.colorFillSecondary} ${theme.colorFillQuaternary}`};
  }
`;
